import { capitalizeFirstLetter } from './capitalizeFirstLetter';

const getUserData = (itemId, users) => {
  if (!itemId) return null;
  const userItem = users.find(({ id }) => id === itemId);
  if (!userItem) return null;
  const { email } = userItem.attributes;
  return {
    email,
    id: itemId,
  };
};

const getUsersData = (arrayId, users) => {
  return users.filter((item) => arrayId?.includes(item.id));
};

const getCampaignData = (itemId, campaigns) => {
  if (!itemId) return null;
  const campaign = campaigns.find(({ id }) => id === itemId);
  if (!campaign) return null;
  const { agency_name: agencyName, campaign_name: campaignName } = campaign.attributes;
  return {
    agencyName,
    campaignName,
    id: itemId,
  };
};

const getRetailerData = (retailerId, retailers, assignmentsId, formId) => {
  if (!retailerId) return null;
  const retailer = retailers.find(({ id }) => id === retailerId);
  if (!retailer) return null;
  const { name, address, city, zipcode } = retailer?.attributes;
  return {
    name: capitalizeFirstLetter(name),
    url: `${formId}/${retailerId}/${assignmentsId}`,
    address,
    zipcode,
    city,
  };
};

const getVisitType = (formId, formList) => {
  if (!formId) return null;
  const form = formList.find(({ id }) => id === formId);
  if (!form) return null;
  const { form_type: formType } = form?.attributes;
  const visitTypeMap = {
    1: 'Assessment',
    2: 'Enforcement',
    3: 'Education',
  };
  return visitTypeMap[formType];
};

export const parseAssignmentsData = ({ data, included }) => {
  const userList = included?.filter(({ type }) => type === 'User');
  const retailerList = included?.filter(({ type }) => type === 'Retailer');
  const campaignList = included?.filter(({ type }) => type === 'Campaign');
  const formList = included?.filter(({ type }) => type === 'Form');

  const assignments = data.map((item) => {
    const { attributes, relationships } = item;
    const { is_follow_up: status } = attributes;

    const campaignID = relationships?.campaign?.data?.id || null;
    const userId = relationships?.users?.data?.[0]?.id || null;
    const formId = relationships?.form?.data?.id || null;
    const retailerId = relationships?.retailer?.data?.id || null;

    const usersIDs = relationships?.users?.data?.map((elem) => elem.id) || [];

    const assignmentItem = {
      id: item.id,
      retailer: getRetailerData(retailerId, retailerList, item.id, formId),
      user: getUserData(userId, userList),
      users: getUsersData(usersIDs, userList),
      visitType: getVisitType(formId, formList),
      campaign: getCampaignData(campaignID, campaignList),
      status,
      _missing: {
        retailerId: !retailerId,
        userId: !userId,
        formId: !formId,
        campaignId: !campaignID,
      },
    };
    return assignmentItem;
  });

  return assignments;
};
